import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"display":"flex"} }
const _hoisted_2 = {
  class: /*@__PURE__*/_normalizeClass({
      'dashboard-wrapper': true,
      }),
  style: {
      padding: '30px 30px 30px 30px',
    }
}
const _hoisted_3 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = { class: "box-title" }
const _hoisted_6 = {
  class: /*@__PURE__*/_normalizeClass({
        'parent': true,
      })
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_document_card = _resolveComponent("document-card")!
  const _component_ciena_layout = _resolveComponent("ciena-layout")!

  return (_openBlock(), _createBlock(_component_ciena_layout, null, {
    "header-left": _withCtx(() => [...(_cache[0] || (_cache[0] = [
      _createElementVNode("span", { class: "heading-4 f-roboto fw-light" }, "EPX Dashboard", -1)
    ]))]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h4", _hoisted_5, "Company " + _toDisplayString(_ctx.id) + " contractors", 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documents, (document) => {
              return (_openBlock(), _createElementBlock("div", {
                key: document.id,
                class: _normalizeClass({
            'child': true,
          })
              }, [
                _createVNode(_component_document_card, {
                  id: document.id,
                  name: document.name,
                  "gradient-type": document.color,
                  "last-edited": document.updated_at,
                  progress: document.answers_progress / 100,
                  "filter-values": document.filter_values,
                  "is-update-pending": document.is_update_pending,
                  "business-function-id": _ctx.businessFunctionId,
                  document: document,
                  onClick: ($event: any) => (_ctx.goToQuizEdit(document.id)),
                  onOnArchive: () => {}
                }, null, 8, ["id", "name", "gradient-type", "last-edited", "progress", "filter-values", "is-update-pending", "business-function-id", "document", "onClick"])
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _: 1
  }))
}